import Konva from "konva";
// import LazyLoad from "vanilla-lazyload";
import AOS from 'aos';
import "./cookieconsent.js";
// import * as Turbo from './turbo.es2017-umd.js';

const applyAddedPdfsToOverview = () => {
    const overview = document.querySelector("#overview");
    if (!overview) {
        console.warn("#overview not found");
    }
    // TODO: implement PDF
    //   return;
    fetch(overview.getAttribute("data-status-url")).then((res) => {
        res.text().then((commaseparatedIDs) => {
            const ids = commaseparatedIDs.split(",");
            const count = ids.length && ids[0] ? ids.length : 0;
            document.querySelector(".downloadPDF .pdfPicturesCount").textContent =
                String(count);
            document.querySelectorAll(`#galleries li`).forEach((el) => {
                if (ids.includes(el.getAttribute("data-id"))) {
                    el.classList.add("isInContactsheet");
                    el.querySelector(".toggleToPDF").classList.add("added");
                } else {
                    el.classList.remove("isInContactsheet");
                    el.querySelector(".toggleToPDF").classList.remove("added");
                }
            });
        });
    });
};

const keyboardArrowEvents = (document) => {
    document.addEventListener("keydown", (event) => {
        const keyPressed =
            event.keyCode === 37 ? "left" : event.keyCode === 39 ? "right" : null;
        if (keyPressed === "right") {
            document.getElementById("goNext").click();
        }
        if (keyPressed === "left") {
            document.getElementById("goPrev").click();
        }
    });
};

const getCurrentPicture = (document) =>
    document.querySelector("#galleries li.current");

const loadCurrentImage = (document, doNotReloadPicture = false) => {
    const currentPicture = getCurrentPicture(document);
    const body = document.querySelector("body");
    // clear all previous class names
    [
        "topLeftBright",
        "topRightBright",
        "bottomLeftBright",
        "bottomRightBright"
    ].forEach((className) => {
        body.classList.remove(className);
    });

    function preloadPreviousAndNextImage() {
        let picturesToLoad = [];
        if (currentPicture.previousElementSibling) {
            picturesToLoad.push(currentPicture.previousElementSibling);
            // (new Image()).src = currentPicture.previousElementSibling.dataset.url;
        } else {
            picturesToLoad.push(currentPicture.parentElement.lastElementChild);
        }
        if (currentPicture.nextElementSibling) {
            picturesToLoad.push(currentPicture.nextElementSibling);
            // (new Image()).src = currentPicture.nextElementSibling.dataset.url;
        } else {
            picturesToLoad.push(currentPicture.parentElement.firstElementChild);
        }
        // load surrounding images
        picturesToLoad.forEach((picture) => {
            if (!picture) {
                return;
            }
            let image = new Image();
            image.srcset = picture.dataset.srcset;
            image.src = picture.dataset.url;
        });
    }

    preloadPreviousAndNextImage();

    const pictureContainer = document.querySelector("#currentPictures");
    const fullSizeUrl = currentPicture.getAttribute("data-url");
    const smallSizeUrl = currentPicture.getAttribute("data-small-preview-url");
    const picture = document.querySelector("#currentPictures > .picture.current");
    const preloadedPicture = document.querySelector(
        "#currentPictures > .picture.preloaded"
    );

    if (!doNotReloadPicture) {
        // just remove the blurry image for a nicer fade
        preloadedPicture.style["backgroundImage"] = null;
        preloadedPicture.style["--image-url"] = null;
        pictureContainer.classList.add("loading");
        setTimeout(() => {
            preloadedPicture.style["backgroundImage"] = "url(" + smallSizeUrl + ")";
            preloadedPicture.style["--image-url"] = "url(" + smallSizeUrl + ")";
            pictureContainer.classList.remove("loading");
            picture.style["backgroundImage"] = "url(" + fullSizeUrl + ")";
            picture.style["--image-url"] = "url(" + fullSizeUrl + ")";
        }, 400);
    }

    const darkLightThreshold = 120;
    const isAboveThreshold = (x, y, layer) => {
        let {data} = layer.getCanvas().getContext("2d").getImageData(x, y, 1, 1);
        return data[0] >= darkLightThreshold;
    };

    Konva.Image.fromURL(currentPicture.dataset.smallPreviewUrl, function (image) {
        let pixelSize = image.width() / 1.5;

        image.cache();
        image.filters([Konva.Filters.Pixelate, Konva.Filters.Grayscale]);
        image.pixelSize(pixelSize);

        var layer = new Konva.Layer();
        layer.add(image);

        var stage = new Konva.Stage({
            container: "#tmpCanvas",
            // container:  '#currentPictures',
            width: image.width(),
            height: image.height()
        });
        stage.add(layer);
        layer.batchDraw();

        let pixelRatio = layer.getCanvas().pixelRatio;

        let map = [
            [1, 1],
            [image.width() * pixelRatio - 1, 1],
            [1, image.height() * pixelRatio - 1],
            [image.width() * pixelRatio - 1, image.height() * pixelRatio - 1]
        ];

        let thresholds = [
            isAboveThreshold(map[0][0], map[0][1], layer),
            isAboveThreshold(map[1][0], map[1][1], layer),
            isAboveThreshold(map[2][0], map[2][1], layer),
            isAboveThreshold(map[3][0], map[3][1], layer)
        ];

        if (thresholds[0]) {
            body.classList.add("topLeftBright");
        }
        if (thresholds[1]) {
            body.classList.add("topRightBright");
        }
        if (thresholds[2]) {
            body.classList.add("bottomLeftBright");
        }
        if (thresholds[3]) {
            body.classList.add("bottomRightBright");
        }
    });

    document.querySelector("#leftContent").innerText =
        currentPicture.getAttribute("data-left-content");
    document.querySelector("#rightContent").innerText =
        currentPicture.getAttribute("data-right-content");

    // history url
    if (!doNotReloadPicture) {
        document.title = currentPicture.getAttribute("data-title");
        history.pushState(
            null,
            currentPicture.getAttribute("data-title"),
            currentPicture.getAttribute("data-link")
        );
    }
};

const userAgentIsMobile = () => {
    return (
        window.getComputedStyle(document.getElementById("bottomNavigation"))[
            "display"
            ] === "none"
    );
};

const getNextSiblingFromNestedGalleries = (el) => {
    let nextSibling = null;
    if (el.nextElementSibling) {
        nextSibling = el.nextElementSibling;
    } else if (el.parentElement.nextElementSibling) {
        let nextElementSibling = el.parentElement.nextElementSibling;
        while (nextElementSibling && nextElementSibling.nodeName !== "UL") {
            nextElementSibling = nextElementSibling.nextElementSibling;
        }
        nextSibling = nextElementSibling.querySelector("li:first-of-type");
    } else {
        nextSibling = document.querySelector("#galleries li:first-of-type");
    }
    return nextSibling;
};

const getPreviousSiblingFromNestedGalleries = (el) => {
    let prevSibling = null;
    if (el.previousElementSibling) {
        prevSibling = el.previousElementSibling;
    } else if (el.parentElement.previousElementSibling) {
        prevSibling =
            el.parentElement.previousElementSibling.querySelector("li:last-of-type");
    } else {
        // load last image
        prevSibling = document.querySelector(
            "#galleries ul:last-of-type li:last-of-type"
        );
    }
    return prevSibling;
};

const preloadFullSizeImages = (document) => {
    let currentPicture = getCurrentPicture(document);
    let nextPic = currentPicture;
    let prevPic = currentPicture;
    let loadingStack = [];

    while (
        document.querySelector("#galleries li:not(.loading)") &&
        (nextPic || prevPic)
        ) {
        if (nextPic) {
            loadingStack.push(nextPic);
            nextPic.classList.add("loading");
            nextPic = getNextSiblingFromNestedGalleries(nextPic);
        }
        if (prevPic) {
            loadingStack.push(prevPic);
            prevPic.classList.add("loading");
            prevPic = getPreviousSiblingFromNestedGalleries(prevPic);
        }
    }

    // loads all pics sequentially
    let i = 0;
    let debugLoading = false;

    loadingStack.reduce((previousPromise, li) => {
        return previousPromise.then(() => {
            return new Promise((resolve) => {
                i += 1;
                if (debugLoading) {
                    console.log("Starts", i);
                }
                const img = li.querySelector("img");
                img.addEventListener("load", () => {
                    let percentageDone = (100 / loadingStack.length) * i;
                    document.getElementById("loadingPicturesProgressBar").style.width =
                        String(percentageDone) + "%";
                    if (percentageDone >= 98) {
                        setTimeout(
                            () =>
                                document
                                    .getElementById("loadingPicturesProgressBar")
                                    .classList.add("hidden"),
                            200
                        );
                    }
                    li.classList.remove("loading");
                    if (debugLoading) {
                        console.log("Done", i);
                    }
                    resolve();
                });
                img.setAttribute("src", li.getAttribute("data-url"));
                img.classList.add("fully-loaded");
            });
        });
    }, Promise.resolve());
};

const hideGalleryControls = (document) =>
    document.querySelector("body").classList.add("hideGalleryControls");
const displayGalleryControls = (document) =>
    document.querySelector("body").classList.remove("hideGalleryControls");

const applyPhotoNavigation = (document) => {
    const loadNextPhoto = (ev) => {
        hideGalleryControls(document);
        hideBottomMenu(document);
        let currentPicture = getCurrentPicture(document);
        currentPicture.classList.remove("current");
        getNextSiblingFromNestedGalleries(currentPicture).classList.add("current");
        loadCurrentImage(document);
    };
    const loadPreviousPhoto = (ev) => {
        hideGalleryControls(document);
        hideBottomMenu(document);
        let currentPicture = getCurrentPicture(document);
        currentPicture.classList.remove("current");
        getPreviousSiblingFromNestedGalleries(currentPicture).classList.add(
            "current"
        );
        loadCurrentImage(document);
    };
    document.getElementById("goNext").addEventListener("click", loadNextPhoto);
    document
        .getElementById("goPrev")
        .addEventListener("click", loadPreviousPhoto);
};

const overviewOnClickEvent = (e) => {
    e.preventDefault();
    const body = document.querySelector("body");
    body.classList.toggle("displayOverview");
    body.classList.remove("displayContentPagesNavigation");

    const overviewNavigation = e.currentTarget;
    const galleryItems = document.querySelectorAll("#galleries li");
    galleryItems.forEach((li) => li.classList.remove("visible"));
    let i = 0;
    const overviewIsDisplayed = body.classList.contains("displayOverview");

    if (!overviewIsDisplayed && location.hash === "#contactsheet") {
        location.hash === "";
    }

    galleryItems.forEach((li) => {
        i += 1;
        setTimeout(
            () => {
                if (overviewIsDisplayed) {
                    li.classList.add("visible");
                } else {
                    li.classList.remove("visible");
                }
            },
            i < 16 ? i * 100 + 200 : 0
        );
    });
};

const onWindowResize = () => {
    if (userAgentIsMobile()) {
        console.info("detected mobile / touch");
        return applyMobileBehaviour(document);
    }
};

const displayBottomMenu = (document) =>
    document.querySelector("body").classList.add("displayBottomMenu");
const hideBottomMenu = (document) =>
    document.querySelector("body").classList.remove("displayBottomMenu");

const applyFadeTransitionInPhotoGalleryContentAndBottomMenu = (document) => {
    let lastFadeOutTimeout = null;
    const stopFadeOutIfQueued = () => {
        if (lastFadeOutTimeout) {
            clearTimeout(lastFadeOutTimeout);
            lastFadeOutTimeout = null;
        }
    };
    const fadeOutLater = (document, timeout = 5000) => {
        stopFadeOutIfQueued();
        lastFadeOutTimeout = setTimeout(() => {
            hideBottomMenu(document);
        }, timeout);
    };

    displayBottomMenu(document);
    fadeOutLater(document);

    document
        .getElementById("menuMouseAreaBottom")
        .addEventListener("mousemove", (ev) => {
            stopFadeOutIfQueued();
            displayBottomMenu(document);
        });
    document
        .getElementById("menuMouseAreaLeft")
        .addEventListener("mouseenter", (ev) => {
            fadeOutLater(document, 0);
        });
    document
        .getElementById("menuMouseAreaRight")
        .addEventListener("mouseenter", (ev) => {
            fadeOutLater(document, 0);
        });
};

const applyMobileBehaviour = (document) => {
    // document.querySelectorAll("#mobilePhotoGalleriesMenu a").forEach((el) => {
    //     el.addEventListener("click", (ev) => {
    //         document.querySelector(`#contentPagesNavigationToggle a[href='#menu']`).click();
    //     });
    // });
    document.querySelector("#mainLogo").addEventListener("click", (ev) => {
        if (document.querySelector('body.displayContentPagesNavigation')) {
            ev.preventDefault();
            document.querySelector('body.displayContentPagesNavigation').classList.remove('displayContentPagesNavigation');
        }
    });

};

function isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
}

function loadMobileGallery() {
    document.querySelector("#backToTop").addEventListener("click", (e) => {
        e.preventDefault();
        window.scrollTo(0, 0);
    });

    const nav = document.querySelector('header.navigation');

    window.addEventListener("scroll", (ev) => {
        if (window.scrollY > 50) {
            document.querySelector("#backToTop").classList.add("visible");
            nav.classList.remove("fade-in");
        } else {
            document.querySelector("#backToTop").classList.remove("visible");
            nav.classList.add("fade-in");
        }
        if (window.scrollY + window.innerHeight > document.body.scrollHeight - 70) {
            document.querySelector("#backToTop").classList.add("full-contrast");
        } else {
            document.querySelector("#backToTop").classList.remove("full-contrast");
        }

    });
    document.querySelectorAll("#galleries li").forEach((a) => {
        a.addEventListener("click", (event) => {
            event.preventDefault();
            event.target.closest("li").classList.toggle("expanded");
        });
    });
}

document.addEventListener(window.Turbo ? 'turbo:load' : 'DOMContentLoaded', function (event) {

    const contentPagesNavigationToggleLink = document.querySelector(
        `#contentPagesNavigationToggle a[href='#menu']`
    );
    contentPagesNavigationToggleLink.addEventListener("click", (e) => {
        e.preventDefault();
        document
            .querySelector("body")
            .classList.toggle("displayContentPagesNavigation");
    });


    AOS.init({
        disable: !isTouchDevice(),
        once: true,
        mirror: true,
    });

    window.cookieconsent.initialise({
        palette: {
            popup: {
                background: "#ffffff"
            },
            button: {
                background: "transparent",
                border: "#000",
                text: "#000"
            }
        },
        position: "bottom-right",
        content: {
            message: "Wir verwenden ausschließlich technisch-essentielle Cookies.",
            dismiss: "OK",
            link: "Mehr Informationen",
            href: "https://www.steffen-jaenicke.de/datenschutz"
        }
    });


    if (isTouchDevice()) {
        console.info("skipping gallery loading for touch devices");
        loadMobileGallery();
        onWindowResize();
        return;
    }

    let assistentinnenRollover = document.querySelector(
        '.secondColumn img[src*="assistentinnen"]'
    );
    if (assistentinnenRollover) {
        let url = "/resources/themes/steffenjaenicke2020/images";
        assistentinnenRollover.setAttribute("src", `${url}/assi01.jpg`);
        assistentinnenRollover.addEventListener("mouseenter", () =>
            assistentinnenRollover.setAttribute("src", `${url}/assi02.jpg`)
        );
        assistentinnenRollover.addEventListener("mouseleave", () =>
            assistentinnenRollover.setAttribute("src", `${url}/assi01.jpg`)
        );
    }

    onWindowResize();

    if (!document.querySelector("body").classList.contains("gallerypage")) {
        console.info("skipping gallery loading");
        return;
    }

    document
        .querySelector("#overviewNavigation > a")
        .addEventListener("click", overviewOnClickEvent);

    let displayContactSheetIfHash = (hash = location.hash) => {
        if (hash === "#contactsheet") {
            document.querySelector("#overviewNavigation > a").click();
        }
        document.querySelector(document.location).scrollIntoView({
            behavior: "smooth"
        });
    };

    window.addEventListener(
        "hashchange",
        function () {
            displayContactSheetIfHash();
        },
        false
    );

    if (document.location.hash) {
        displayContactSheetIfHash(document.location.hash.match(/^#(people|corporate|reportage)$/) ? '#contactsheet' : document.location.hash);
    }

    document.querySelectorAll('a[href^="/pdf"][data-method]').forEach((el) => {
        el.addEventListener("click", (e) => {
            e.preventDefault();
            fetch(e.currentTarget.getAttribute("href"), {
                method: e.currentTarget.getAttribute("data-method")
            }).then((res) => {
                res.text().then((t) => {
                    applyAddedPdfsToOverview();
                });
            });
        });
    });

    document
        .querySelector("#overview .downloadPDF a")
        .addEventListener("click", (ev) => {
            let count = Number(
                ev.currentTarget.querySelector(".pdfPicturesCount").innerText
            );
            if (count < 1) {
                ev.preventDefault();
                alert(
                    "Bitte fügen Sie zuerst ein Bild zu dem PDF Contactsheet hinzu, indem Sie auf das Plus in den roten Felden klicken."
                );
            }
        });

    document
        .getElementById("menuMouseAreaRight")
        .addEventListener("click", () => document.getElementById("goNext").click());
    document
        .getElementById("menuMouseAreaLeft")
        .addEventListener("click", () => document.getElementById("goPrev").click());

    let currentPictureId = document
        .querySelector("#currentPictures img")
        .getAttribute("data-id");
    // this needs to be initially done since everything in html is cached
    document
        .querySelector(`#galleries li[data-id="${currentPictureId}"]`)
        .classList.add("current");

    let imagesPreloaderExecuted = false;

    let imagesPreloader = () => {
        if (imagesPreloaderExecuted) {
            return "Will only be executed once";
        }
        imagesPreloaderExecuted = true;
        console.info("Running images preloader");
        loadCurrentImage(document, true);
        /*
          // This is NOT IN USE ANYMORE, we use native browser lazy loading instead
          preloadFullSizeImages(document);
         */
    };

    document
        .querySelector("#currentPictures .picture.current img")
        .addEventListener("load", imagesPreloader);
    // in chrome, the load event will not be triggered…
    setTimeout(() => imagesPreloader(), 2000);

    applyPhotoNavigation(document);
    applyFadeTransitionInPhotoGalleryContentAndBottomMenu(document);
    applyAddedPdfsToOverview();
    keyboardArrowEvents(document);

    document
        .getElementById("pictureViewContainer")
        .addEventListener("mousemove", () => displayGalleryControls(document));
});

window.addEventListener("resize", onWindowResize);
